import { render, staticRenderFns } from "./minha-carteira.vue?vue&type=template&id=40054b33&v-slot%3Adefault=%7B%20busLeft%20%7D&"
import script from "./minha-carteira.vue?vue&type=script&lang=js&"
export * from "./minha-carteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40054b33')) {
      api.createRecord('40054b33', component.options)
    } else {
      api.reload('40054b33', component.options)
    }
    module.hot.accept("./minha-carteira.vue?vue&type=template&id=40054b33&v-slot%3Adefault=%7B%20busLeft%20%7D&", function () {
      api.rerender('40054b33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/minha-carteira.vue"
export default component.exports